import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import renderTickets from '@components/ticket/render-tickets';
import { StyledIcon } from '@elements/icon/icon.styles';
import { Box } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router';
import EmptyTicket from '@images/empty-ticket.svg';
import { Typography } from '@elements';
import num_word from '@utils/num_word';
import { Link } from 'react-router-dom';
import { useEventSessionById } from '@hooks/useEventSessions';
import Loader from '@components/loader/Loader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var EventDetails = function EventDetails() {
  var _data$seats, _eventSession$seats, _renderTickets;
  var _useParams = useParams(),
    eventId = _useParams.eventId;
  var eventSessionId = eventId ? Number(eventId) : undefined;
  var _React$useState = React.useState(new Set()),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    returnedTicketUuids = _React$useState2[0],
    setReturnedTicketUuids = _React$useState2[1];
  var _useEventSessionById = useEventSessionById(Number.isFinite(eventSessionId) ? eventSessionId : undefined),
    data = _useEventSessionById.data,
    isFetching = _useEventSessionById.isFetching,
    isError = _useEventSessionById.isError;
  var handleRefundSuccess = React.useCallback(function (ticketUuid) {
    setReturnedTicketUuids(function (prev) {
      return new Set(prev).add(ticketUuid);
    });
  }, []);
  var eventSession = data ? _objectSpread(_objectSpread({}, data), {}, {
    seats: ((_data$seats = data.seats) !== null && _data$seats !== void 0 ? _data$seats : []).filter(function (s) {
      return s.ticketUuid && s.active;
    })
  }) : null;
  var ticketsCounts = eventSession ? ((_eventSession$seats = eventSession.seats) !== null && _eventSession$seats !== void 0 ? _eventSession$seats : []).length : 0;
  if (isFetching && !data) {
    return /*#__PURE__*/_jsx(Loader, {
      isShowLoader: true
    });
  }
  if (!eventSession || isError) {
    return /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Typography, {
        color: "white",
        fontSize: 22,
        fontWeight: 400,
        children: "\u041C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E"
      })
    });
  }
  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsxs(Typography, {
      color: "white",
      fontSize: 22,
      fontWeight: 400,
      children: ["\u0423 \u0432\u0430\u0441 ", ticketsCounts, ' ', num_word(ticketsCounts, ['билет', 'билета', 'билетов'])]
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        columnGap: '12px',
        rowGap: '32px',
        mt: '26px',
        flexWrap: 'wrap',
        justifyContent: {
          xs: 'center',
          md: 'start'
        }
      },
      children: [((_renderTickets = renderTickets(eventSession, undefined, {
        returnedTicketUuids: returnedTicketUuids,
        onRefundSuccess: handleRefundSuccess
      })) !== null && _renderTickets !== void 0 ? _renderTickets : []).flat(), /*#__PURE__*/_jsx(Link, {
        to: "".concat(process.env.ticketsUrl, "/events/").concat(eventId),
        target: "_blank",
        children: /*#__PURE__*/_jsx(StyledIcon, {
          src: EmptyTicket,
          width: 288,
          height: 352
        })
      })]
    })]
  });
};
export default EventDetails;